import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import apiClient from '../api/client';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    setSubmitting(true);

    try {
      const response = await apiClient.post('/api/auth/admin-login/', {
        email,
        password,
      });

      const data = response.data;

      const authPayload = {
        admin: data.admin,
        access: data.access,
        refresh: data.refresh,
      };

      login(authPayload);
      navigate('/', { replace: true });
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError('Invalid email or password.');
      } else {
        setError('Unable to connect to server. Please try again.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-form-header">
          <div className="auth-brand">
            <img
              src={`${process.env.PUBLIC_URL}/ep-logo-login.png`}
              alt="EPT Pravahaa"
              className="auth-logo-img"
            />
            <p className="auth-brand-title">Edu Pravahaa</p>
          </div>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
            <div>
              <label className="auth-label" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                className="auth-input"
                type="email"
                placeholder="you@institution.edu"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>

            <div>
              <label className="auth-label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                className="auth-input"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            {error && <p className="auth-error">{error}</p>}

            <button
              className="auth-primary-btn"
              type="submit"
              disabled={submitting}
            >
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>

            <p className="auth-hint">
              This is a secure admin area. <strong>Do not</strong> share your
              credentials with students or external users.
            </p>
          </form>
      </div>
    </div>
  );
}

export default Login;
